import PropTypes from 'prop-types';

export const mapOptionPropTypes = {
  fullscreenControl: PropTypes.bool,
  fullscreenControlOptions: PropTypes.object,
  mapTypeControl: PropTypes.bool,
  mapTypeControlOptions: PropTypes.object,
  maxZoom: PropTypes.number,
  rotateControl: PropTypes.bool,
  rotateControlOptions: PropTypes.object,
  scaleControl: PropTypes.bool,
  scaleControlOptions: PropTypes.object,
  streetViewControl: PropTypes.bool,
  streetViewControlOptions: PropTypes.object,
  zoomControl: PropTypes.bool,
  zoomControlOptions: PropTypes.object
};

export const markerEvents = ['click', 'mouseover', 'mouseout'];

// @googlemaps/markerclusterer renders clusters via a `renderer` (there is no
// built-in styles/calculator like MarkerClustererPlus had). This reproduces the
// old branded PNG buckets: pick a style by the digit-count of the cluster count
// (1-9 -> bucket 0, 10-99 -> bucket 1, ...) capped at the number of styles,
// matching MarkerClustererPlus's default calculator, and draw the count on top
// of the bucket image. `gmpClickable` is required for the library's default
// zoom-on-cluster-click to fire on map-id (AdvancedMarkerElement) maps.
export const buildClustererRenderer = styles => ({
  render: ({ count, position }) => {
    const style = styles[Math.min(String(count).length, styles.length) - 1];
    const div = document.createElement('div');
    div.textContent = String(count);
    Object.assign(div.style, {
      alignItems: 'center',
      backgroundImage: `url(${style.url})`,
      backgroundSize: 'contain',
      color: style.textColor,
      display: 'flex',
      fontSize: `${style.textSize}px`,
      height: `${style.height}px`,
      justifyContent: 'center',
      width: `${style.width}px`,
    });

    return new google.maps.marker.AdvancedMarkerElement({
      content: div,
      gmpClickable: true,
      position,
    });
  },
});

// AdvancedMarkerElement dispatches its click via the `gmp-click` event (the
// plain `click` listener is deprecated and emits a console warning). Hover
// events aren't dispatched through addListener at all and must be attached as
// DOM listeners on the marker's content (or the marker element itself when no
// custom content is set).
export const addAdvancedMarkerEventListener = (marker, event, handler) => {
  if (event === 'click') {
    marker.addListener('gmp-click', handler);
    return;
  }
  const target = marker.content || marker.element || marker;
  target.addEventListener(event, handler);
};
export const mapStyles = {
  container: {
    position: 'absolute',
    width: '100%',
    height: '100%'
  },
  map: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    top: 0
  }
};
